import { BannersSchema } from './Banners.schema';

export const state: BannersSchema = {
  data: {
    banners: [],
  },
};
